import Axios from 'axios';
import { call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  GET_PAGE_ITEM_OPERATIONS,
  GET_ALERT_LISTING_COLUMN_NAMES,
  GET_ALERT_DETAILS_COLUMN_NAMES,
  GET_TM_ALERTS_LISTING_SETTINGS,
  PUT_TM_ALERTS_LISTING_SETTINGS,
  //phase 3
  GET_GLOBAL_SETTINGS_PAGE_INFO,
  PUT_GLOBAL_SETTINGS_WIDGET_GROUP,
  PUT_GLOBAL_SETTINGS_WIDGETS,
  PUT_GLOBAL_SETTINGS_WIDGET_INFO,
  getPageItemOperationsSuccess,
  getPageItemOperationsFail,
  getAlertListingColumnNamesSuccess,
  getAlertListingColumnNamesFail,
  getAlertDetailsColumnNamesSuccess,
  getAlertDetailsColumnNamesFail,
  getTMAlertsListingSettingsSuccess,
  getTMAlertsListingSettingsFail,
  putTMAlertsListingSettingsSuccess,
  putTMAlertsListingSettingsFail,

  //phase 3
  getGlobalSettingsPageInfoSuccess,
  getGlobalSettingsPageInfoFail,
  putGlobalSettingsWidgetGroupSuccess,
  putGlobalSettingsWidgetGroupFail,
  putGlobalSettingsWidgetsSuccess,
  putGlobalSettingsWidgetsFail,
  putGlobalSettingsWidgetInfoSuccess,
  putGlobalSettingsWidgetInfoFail,
  //NS-IAD
  GET_NS_GLOBAL_SETTINGS_PAGE_INFO,
  getNSGlobalSettingsPageInfoSuccess,
  getNSGlobalSettingsPageInfoFail,
  //AMLS COMMON
  GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO,
  getAMLSCommonGlobalSettingsPageInfoSuccess,
  getAMLSCommonGlobalSettingsPageInfoFail,

  // TM-IAD CREATE RUN INSTANCE
  GET_LIVE_SETS_RUN_INSTANCE,
  POST_SEGMENT_SETS_RUN_INSTANCE,
  GET_CATEGORIES_CREATE_RUN_INSTANCE,
  getCategoriesSuccess,
  getLiveSetsSuccess,
  postSegmentSetsSuccess,
  getCategoriesFail,
  getLiveSetsFail,
  postSegmentSetsFail
} from '../redux/actions/settings';

import {
  alertDetailsColumnNamesAPI,
  alertListingColumnNamesAPI,
  amlsCommonGlobalSettingsAPI,
  fetchCategoriesAPI,
  fetchLiveSetsAPI,
  globalSettingsPageInfoAPI,
  nsMatchingConfigListingSettingsAPI,
  postSegmentSetsAPI,
  putGlobalSettingsWidgetGroupAPI,
  putGlobalSettingsWidgetInfoAPI,
  putGlobalSettingsWidgetsAPI,
  putTmAlertListingSettingsAPI,
  tmAlertListingSettingsAPI,
  widgetColumnItemsAPI
} from '../services/settings';

// create run instance sagas

function* postSegmentSetsRunInstanceDataWorker(payload) {
  try {
    const response = yield call(postSegmentSetsAPI, payload);

    yield put(postSegmentSetsSuccess(response));
  } catch (error) {
    yield put(postSegmentSetsFail(error.message));
  }
}

export function* watchPostSegmentSetsRunInstance() {
  yield takeEvery(POST_SEGMENT_SETS_RUN_INSTANCE, function* ({ payload }) {
    yield fork(postSegmentSetsRunInstanceDataWorker, payload);
  });
}

function* getLiveSetsRunInstanceDataWorker(payload) {
  try {
    const response = yield call(fetchLiveSetsAPI, payload);

    yield put(getLiveSetsSuccess(response));
  } catch (error) {
    yield put(getLiveSetsFail({ error }));
  }
}

export function* watchGetLiveSetsRunInstance() {
  yield takeEvery(GET_LIVE_SETS_RUN_INSTANCE, function* ({ payload }) {
    yield fork(getLiveSetsRunInstanceDataWorker, payload);
  });
}

function* getCategoriesRunInstanceDataWorker(payload) {
  try {
    const response = yield call(fetchCategoriesAPI, payload);

    yield put(getCategoriesSuccess(response));
  } catch (error) {
    yield put(getCategoriesFail({ error }));
  }
}

export function* watchGetCategoriesRunInstance() {
  yield takeEvery(GET_CATEGORIES_CREATE_RUN_INSTANCE, function* ({ payload }) {
    yield fork(getCategoriesRunInstanceDataWorker, payload);
  });
}

// global settings sagas

function* getPageItemOperationsDataWorker(payload) {
  try {
    const response = yield call(widgetColumnItemsAPI, payload);

    yield put(getPageItemOperationsSuccess(response));
  } catch (error) {
    yield put(getPageItemOperationsFail({ error }));
  }
}

export function* watchTMGetPageItemOperations() {
  yield takeEvery(GET_PAGE_ITEM_OPERATIONS, function* ({ payload }) {
    yield fork(getPageItemOperationsDataWorker, payload);
  });
}

function* getAlertListingColumnsDataWorker(payload) {
  try {
    const response = yield call(alertListingColumnNamesAPI, payload);

    yield put(getAlertListingColumnNamesSuccess(response));
  } catch (error) {
    yield put(getAlertListingColumnNamesFail({ error }));
  }
}

export function* watchTMGetAlertListingColumns() {
  yield takeEvery(GET_ALERT_LISTING_COLUMN_NAMES, function* ({ payload }) {
    yield fork(getAlertListingColumnsDataWorker, payload);
  });
}

function* getAlertDetailsColumnsDataWorker(payload) {
  try {
    const response = yield call(alertDetailsColumnNamesAPI, payload);

    yield put(getAlertDetailsColumnNamesSuccess(response));
  } catch (error) {
    yield put(getAlertDetailsColumnNamesFail({ error }));
  }
}

export function* watchTMAlertDetailsColumns() {
  yield takeEvery(GET_ALERT_DETAILS_COLUMN_NAMES, function* ({ payload }) {
    yield fork(getAlertDetailsColumnsDataWorker, payload);
  });
}

function* getAlertsListingSettings(payload) {
  try {
    const response = yield call(tmAlertListingSettingsAPI, payload);

    yield put(getTMAlertsListingSettingsSuccess(response));
  } catch (error) {
    yield put(getTMAlertsListingSettingsFail({ error }));
  }
}

export function* watchTMGetAlertsListingSettings() {
  yield takeEvery(GET_TM_ALERTS_LISTING_SETTINGS, function* ({ payload }) {
    yield fork(getAlertsListingSettings, payload);
  });
}

function* putAlertsListingSettings(payload) {
  try {
    const response = yield call(putTmAlertListingSettingsAPI, payload);
    yield put(putTMAlertsListingSettingsSuccess(response));
  } catch (error) {
    yield put(putTMAlertsListingSettingsFail({ error }));
  }
}

export function* watchTMPutAlertsListingSettings() {
  yield takeEvery(PUT_TM_ALERTS_LISTING_SETTINGS, function* ({ payload }) {
    yield fork(putAlertsListingSettings, payload);
  });
}

function* getGlobalSettingsPageInfo(payload) {
  try {
    const response = yield call(globalSettingsPageInfoAPI, payload);

    yield put(getGlobalSettingsPageInfoSuccess(response));
  } catch (error) {
    yield put(getGlobalSettingsPageInfoFail({ error }));
  }
}

export function* watchGetGlobalSettingsPageInfo() {
  yield takeLatest(GET_GLOBAL_SETTINGS_PAGE_INFO, function* ({ payload }) {
    yield fork(getGlobalSettingsPageInfo, payload);
  });
}

function* nsMatchingConfigListingSettings(payload) {
  try {
    const response = yield call(nsMatchingConfigListingSettingsAPI, payload);

    yield put(getNSGlobalSettingsPageInfoSuccess(response));
  } catch (error) {
    if (!Axios.isCancel(error)) {
      yield put(getNSGlobalSettingsPageInfoFail({ error }));
    }
  }
}

export function* watchNSMatchingConfigListingSettings() {
  yield takeEvery(GET_NS_GLOBAL_SETTINGS_PAGE_INFO, function* ({ payload }) {
    yield fork(nsMatchingConfigListingSettings, payload);
  });
}

function* putGlobalSettingsWidgetGroup(payload) {
  try {
    const response = yield call(putGlobalSettingsWidgetGroupAPI, payload);
    yield put(putGlobalSettingsWidgetGroupSuccess(response));
  } catch (error) {
    yield put(putGlobalSettingsWidgetGroupFail({ error }));
  }
}

export function* watchPutGlobalSettingsWidgetGroup() {
  yield takeEvery(PUT_GLOBAL_SETTINGS_WIDGET_GROUP, function* ({ payload }) {
    yield fork(putGlobalSettingsWidgetGroup, payload);
  });
}

function* putGlobalSettingsWidgets(payload) {
  try {
    const response = yield call(putGlobalSettingsWidgetsAPI, payload);
    yield put(putGlobalSettingsWidgetsSuccess(response));
  } catch (error) {
    yield put(putGlobalSettingsWidgetsFail({ error }));
  }
}

export function* watchPutGlobalSettingsWidgets() {
  yield takeEvery(PUT_GLOBAL_SETTINGS_WIDGETS, function* ({ payload }) {
    yield fork(putGlobalSettingsWidgets, payload);
  });
}

function* putGlobalSettingsWidgetInfo(payload) {
  try {
    const response = yield call(putGlobalSettingsWidgetInfoAPI, payload);
    yield put(putGlobalSettingsWidgetInfoSuccess(response));
  } catch (error) {
    yield put(putGlobalSettingsWidgetInfoFail({ error }));
  }
}

export function* watchPutGlobalSettingsWidgetInfo() {
  yield takeEvery(PUT_GLOBAL_SETTINGS_WIDGET_INFO, function* ({ payload }) {
    yield fork(putGlobalSettingsWidgetInfo, payload);
  });
}

function* amlsCommonGlobalSettings(payload) {
  try {
    const response = yield call(amlsCommonGlobalSettingsAPI, payload);

    yield put(getAMLSCommonGlobalSettingsPageInfoSuccess(response));
  } catch (error) {
    yield put(getAMLSCommonGlobalSettingsPageInfoFail({ error }));
  }
}

export function* watchAMLSCommonGlobalSettings() {
  yield takeEvery(
    GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO,
    function* ({ payload }) {
      yield fork(amlsCommonGlobalSettings, payload);
    }
  );
}
